import { MaAssetEntityTypeEnum } from '@/types/GraphqlSchema';
import type { EntitySelection } from './portfolioBridgeStore';

export const isEntityEqual = (a: EntitySelection, b: EntitySelection): boolean => {
  if (a.type !== b.type) return false;

  switch (a.type) {
    case MaAssetEntityTypeEnum.Asset:
      return (
        a.legacyId === (b as typeof a).legacyId &&
        a.country.isoCode === (b as typeof a).country.isoCode
      );
    case MaAssetEntityTypeEnum.Block:
    case MaAssetEntityTypeEnum.Field:
      return a.id === (b as typeof a).id && a.country.isoCode === (b as typeof a).country.isoCode;
    default:
      return false;
  }
};

export const updateStats = (entities: EntitySelection[]) => {
  const totalAssets = entities.filter(e => e.type === MaAssetEntityTypeEnum.Asset).length;
  const totalBlocks = entities.filter(e => e.type === MaAssetEntityTypeEnum.Block).length;
  const totalFields = entities.filter(e => e.type === MaAssetEntityTypeEnum.Field).length;
  const total = entities.length;

  return { totalAssets, totalBlocks, totalFields, total };
};
